import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M52.42 1.03003V1C52.2 1 51.9999 1.01001 51.7799 1.01001C51.5699 1.01001 51.36 1 51.14 1V1.03003C13.75 1.63003 -2.14007 28.59 2.64993 53.85C7.48993 79.39 29.95 88.64 29.95 88.64H73.5999C73.5999 88.64 96.0599 79.39 100.9 53.85C105.7 28.59 89.81 1.63003 52.42 1.03003Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </g>
  )
}
